import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { HexonAds } from './Ads';
import { HBox } from '../../../components/Box';
import { fetchControlPanelUrl } from '../actions';
import { selectHexonControlPanelUrl } from '../selectors';
import { selectWork } from '../../Api/selectors';
import { FETCH_HEXON_CONTROL_PANEL_URL } from '../constants';

const Container = styled.div``;
const STATE = {
};
/* eslint-disable react/prefer-stateless-function */
class ControlPanelComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount(){
    this.props.fetch()
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
      <iframe width="100%" border="0" frameBorder="0" src={this.props.controlPanelUrl} height="900"></iframe>
      </Container>
    );
  }
}

ControlPanelComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
    work : selectWork(FETCH_HEXON_CONTROL_PANEL_URL),
    controlPanelUrl : selectHexonControlPanelUrl()
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(){
        dispatch(fetchControlPanelUrl());
    }
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ControlPanel = compose(
  withConnect,
  withRouter,
)(ControlPanelComp);
